import React from "react";
import styled from "styled-components";

// Styling components
const Container = styled.div`
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
  border-radius: 8px;
`;

const Title = styled.h1`
  text-align: center;
  color: #006a71;
  margin-bottom: 20px;
`;

const Subtitle = styled.h2`
  color: #333;
  margin-top: 20px;
`;

const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
`;

const List = styled.ul`
  padding-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
  color: #555;
`;

const Bold = styled.span`
  font-weight: bold;
`;

const Link = styled.a`
  color: #006a71;
  text-decoration: none;
`;

const TripHop = () => {
  return (
    <Container>
      <Title>BariJabo Privacy Policy</Title>
      <Paragraph>
        <Bold>Last updated:</Bold> December 05, 2025
      </Paragraph>

      <Subtitle>Information We Collect</Subtitle>
      <List>
        <ListItem>
          <Bold>Account & Profile:</Bold> Name, email, password, phone number,
          role (user/driver/admin), and more.
        </ListItem>
        <ListItem>
          <Bold>Authentication & Identifiers:</Bold> Firebase UID, device
          identifiers, push notification tokens.
        </ListItem>
        <ListItem>
          <Bold>Location:</Bold> Driver location during trips, optional device
          location for users.
        </ListItem>
        <ListItem>
          <Bold>Ride & Booking Data:</Bold> Pickup/drop-off, ride status,
          pricing, and ratings.
        </ListItem>
        <ListItem>
          <Bold>Media:</Bold> Photos uploaded for vehicles or profiles.
        </ListItem>
        <ListItem>
          <Bold>Usage & Diagnostics:</Bold> App interactions, crash logs, and
          performance data.
        </ListItem>
      </List>

      <Subtitle>How We Use Information</Subtitle>
      <Paragraph>
        We use your information to operate and improve our services, ensure
        safety, prevent fraud, and comply with legal obligations.
      </Paragraph>

      <Subtitle>Sharing & Disclosure</Subtitle>
      <Paragraph>
        We share data only with service providers such as Firebase, Google, and
        for legal compliance. We do not sell your personal information.
      </Paragraph>

      <Subtitle>Data Retention</Subtitle>
      <Paragraph>
        We retain data for as long as needed to provide our services and comply
        with legal requirements.
      </Paragraph>

      <Subtitle>Your Choices & Rights</Subtitle>
      <Paragraph>
        You can access, update, and delete your profile data and manage location
        and notifications. To delete your account, contact us directly.
      </Paragraph>

      <Subtitle>Security</Subtitle>
      <Paragraph>
        We use encryption and industry-standard safeguards to protect your data,
        though no method is completely secure.
      </Paragraph>

      <Subtitle>Children</Subtitle>
      <Paragraph>
        Our service is not intended for children under 13, and we do not
        knowingly collect data from children.
      </Paragraph>

      <Subtitle>International Transfers</Subtitle>
      <Paragraph>
        Your data may be stored on servers located outside your country. By
        using our services, you consent to such transfers.
      </Paragraph>

      <Subtitle>Permissions Used</Subtitle>
      <List>
        <ListItem>
          <Bold>Location:</Bold> For driver location sharing and pickup/drop-off
          help.
        </ListItem>
        <ListItem>
          <Bold>Camera & Photos:</Bold> To upload profile and vehicle images.
        </ListItem>
        <ListItem>
          <Bold>Notifications:</Bold> To send ride updates and important alerts.
        </ListItem>
      </List>

      <Subtitle>Changes to This Policy</Subtitle>
      <Paragraph>
        We may update this policy and will notify users of any material changes.
        Continued use of the service implies acceptance of the updated policy.
      </Paragraph>

      <Subtitle>Contact Us</Subtitle>
      <Paragraph>
        If you have questions or wish to exercise your rights, contact us at{" "}
        <Link href="mailto:zayn.miraj@gmail.com">zayn.miraj@gmail.com</Link>.
      </Paragraph>
    </Container>
  );
};

export default TripHop;
